import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import {
  AppBar,
  Toolbar,
  IconButton,
  Badge,
  Grid,
  MenuItem,
  Menu,
  SwipeableDrawer,
  List,
  ListItem,
  Avatar,
  ListItemAvatar,
  ListItemText,
  Typography,
  ListItemButton,
  Box,
} from '@mui/material';
import {
  AccountBalanceWalletOutlined,
  AccountBalanceWallet,
  HomeOutlined,
  Home,
  MailOutline,
  Mail,
  MenuOutlined,
  ChevronLeft,
} from '@mui/icons-material';

import LoggedRoutes from 'js/containers/Routes/LoggedRoutes';
import HomeTriibos from 'js/containers/Home/HomeTriibos';
import HomeTriibosSuggestion from 'js/containers/Home/HomeTriibosSuggestion';
import HomeImage from 'js/containers/Home/HomeImage';
import HomeTriibosCarousel from 'js/containers/Home/HomeTriibosCarousel';
//import DownloadApp from 'js/containers/Home/DownloadApp';
import Footer from 'js/containers/Footer/Footer';
import SearchBar from 'js/containers/Search/SearchBar';
import Loading from 'js/containers/Loading/Loading';
// import DownloadAppModal from "js/containers/Drawer/DownloadAppModal";
import LoginModal from 'js/containers/Login/LoginModal';

import { logout, checkUserStatus } from 'js/library/services/AuthenticationManager.js';
import { getLastUserInfo, trackEventMatomo } from 'js/library/utils/helpers';
import createAnonymous from 'js/library/utils/API/createAnonymous';

import thumbWhite from 'styles/assets/thumb_white.png';
import Profile_Avatar from 'styles/assets/avatar/Profile_Avatar.png';
import { avatar } from 'styles/avatar';
import { getBalance_v1 } from 'js/library/utils/API/getBalance_v1.js';
import { LanguageSwitcher } from './languageSwitcher';

export default function PrimarySearchAppBar() {
  const { t } = useTranslation();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [drawerOpened, setDrawerOpened] = React.useState(false);
  const [authenticated, setAuthenticated] = React.useState(false);
  const [points, setPoints] = React.useState(0);
  const [orgs, reloadOrgs] = React.useState(false);
  const [openState, setOpenState] = React.useState(false);
  const location = useLocation();

  const isMenuOpen = Boolean(anchorEl);
  const userInfo = getLastUserInfo();

  let isAnonymous = userInfo !== null;
  isAnonymous = isAnonymous ? userInfo.triiboId?.indexOf('@anonymous-triibo.com.br') >= 0 : false;

  const styles = {
    grow: { flexGrow: 1 },
    menuButton: { mr: 2 },
    title: {
      display: { xs: 'none', sm: 'block' },
      mr: 2,
    },
    sectionDesktop: {
      display: { xs: 'none', md: 'flex' },
      width: '100%',
    },
    sectionIcons: {
      display: 'flex',
      width: '80%',
      placeContent: 'center',
      alignItems: 'center',
    },
    sectionAvatar: {
      display: 'flex',
    },
    sectionMobile: {
      display: { xs: 'flex', md: 'none' },
    },
    drawer: {
      width: 240,
    },
  };

  useEffect(() => {
    checkUserStatus()
      .then(async (resp) => {
        if (userInfo === null || resp === null) {
          logout();
          const user = await createAnonymous();
          if (authenticated === false) setAuthenticated(user);
        } else {
          if (!isAnonymous) {
            let balanceReceived = {};

            balanceReceived = await getBalance_v1(userInfo.uId, userInfo.triiboId);

            setPoints(
              balanceReceived.consolidateBalance && balanceReceived.consolidateBalance.total
            );
          }
          setAuthenticated(resp);
        }
      })
      .catch(async (error) => {
        const user = await createAnonymous();
        setAuthenticated(user);
      });
  }, [isAnonymous, authenticated, userInfo]);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
    trackEventMatomo('Menu', 'tocar', 'botao', 'menu hamburguer');
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerOpen = () => {
    setDrawerOpened(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpened(false);
  };

  const thumb =
    !userInfo || userInfo.thumbnail === undefined ? Profile_Avatar : avatar[userInfo.thumbnail];

  const openAnonymousModal = () => {
    setDrawerOpened(false);
    setAnchorEl(null);
    setOpenState(true);
  };

  const handleLogout = () => {
    trackEventMatomo('Menu', 'tocar', 'botao', 'sair');
    logout();
  };

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <h3>Mais</h3>
      <div>
        {isAnonymous ? (
          <MenuItem>
            <Link
              to="#"
              style={{ textDecoration: 'none', color: '#6D3195' }}
              onClick={() => {
                openAnonymousModal();
                trackEventMatomo('Menu', 'tocar', 'botao', 'meu perfil');
              }}
            >
              {t('drawer.my_profile')}
            </Link>
          </MenuItem>
        ) : (
          <MenuItem>
            <Link
              onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'meu perfil')}
              to="/meusDados"
              style={{ textDecoration: 'none', color: '#6D3195' }}
            >
              {t('drawer.my_profile')}
            </Link>
          </MenuItem>
        )}
        <MenuItem>
          <Link
            onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'o que é a triibo')}
            to="/sobre"
            style={{ textDecoration: 'none', color: '#6D3195' }}
          >
            {t('drawer.what_is_triibo')}
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'como usar')}
            to="/como-usar"
            style={{ textDecoration: 'none', color: '#6D3195' }}
          >
            {t('drawer.how_to_use')}
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            target="_blank"
            onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'solucoes para empresas')}
            to="https://triibo.com.br/triibo-negocios/"
            style={{ textDecoration: 'none', color: '#6D3195' }}
          >
            {t('drawer.solutions_triibo')}
          </Link>
        </MenuItem>
      </div>
      <div>
        <MenuItem>
          <Link
            onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'fale conosco')}
            to="/fale-conosco"
            style={{ textDecoration: 'none', color: '#6D3195' }}
          >
            {t('drawer.contact_us')}
          </Link>
        </MenuItem>
        <MenuItem>
          <a
            href={document.location.origin + '/termos-de-uso-dos-servicos-triibo/'}
            target="new"
            style={{ textDecoration: 'none', color: '#6D3195' }}
          >
            {t('drawer.terms_and_policies')}
          </a>
        </MenuItem>
        {isAnonymous ? (
          <MenuItem>
            <Link to="/login" style={{ textDecoration: 'none', color: '#6D3195' }}>
              <strong>{t('drawer.login')}</strong>
            </Link>
          </MenuItem>
        ) : (
          <MenuItem onClick={() => handleLogout()}>
            <a href={document.location.origin} style={{ textDecoration: 'none', color: '#6D3195' }}>
              <strong>{t('drawer.exit')}</strong>
            </a>
          </MenuItem>
        )}
      </div>

      {/* MODAL PARA BAIXAR APP TRIIBO */}
      {/* <DownloadAppModal /> */}
    </Menu>
  );

  const renderMenuMobile = (
    <ul className="menu-mobile">
      <li>
        <Link to="/" onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'Home App')}>
          <IconButton aria-label="home" color="primary">
            <HomeOutlined />
          </IconButton>
        </Link>
      </li>
      {isAnonymous ? (
        <>
          <li>
            <Link
              onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'Caixa de Entrada')}
              to="#"
            >
              <IconButton
                onClick={() => openAnonymousModal()}
                aria-label="Notificações"
                color="primary"
              >
                <Badge color="secondary">
                  <MailOutline />
                </Badge>
              </IconButton>
            </Link>
          </li>
          <li>
            <Link
              onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'Minha Carteira')}
              to="#"
            >
              <IconButton
                onClick={() => openAnonymousModal()}
                aria-label="Minha carteira"
                color="primary"
              >
                <Badge color="secondary">
                  <AccountBalanceWalletOutlined />
                </Badge>
              </IconButton>
            </Link>
          </li>
        </>
      ) : (
        <>
          <li>
            <Link
              onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'Caixa de Entrada')}
              to="/caixaDeEntrada"
            >
              <IconButton aria-label="Notificações" color="primary">
                <Badge color="secondary">
                  <MailOutline />
                </Badge>
              </IconButton>
            </Link>
          </li>
          <li>
            <Link
              onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'Minha Carteira')}
              to="/carteira"
            >
              <IconButton aria-label="Minha carteira" color="primary">
                <Badge color="secondary">
                  <AccountBalanceWalletOutlined />
                </Badge>
              </IconButton>
            </Link>
          </li>
        </>
      )}
      <li>
        <IconButton aria-label="show more" color="primary" onClick={handleDrawerOpen}>
          <MenuOutlined />
        </IconButton>
      </li>
    </ul>
  );

  const renderDrawer = (
    <SwipeableDrawer
      anchor="left"
      open={drawerOpened}
      onClose={handleDrawerClose}
      onOpen={handleDrawerOpen}
    >
      <Box sx={styles.drawer} role="presentation" onClick={handleDrawerClose}>
        <div
          style={{
            backgroundColor: '#eee',
            justifyContent: 'flex-end',
            alignContent: 'center',
            display: 'flex',
          }}
        >
          <IconButton aria-label="voltar" color="primary" onClick={handleDrawerClose}>
            <ChevronLeft style={{ color: '#000' }} />
          </IconButton>
        </div>
        <List>
          {isAnonymous ? (
            <ListItemButton style={{ padding: 0 }}>
              <Link
                to="#"
                onClick={() => {
                  openAnonymousModal();
                  trackEventMatomo('Menu', 'tocar', 'botao', 'meu perfil');
                }}
                style={{
                  width: '100%',
                  padding: '8px 16px',
                  color: '#000',
                  textDecoration: 'none',
                }}
              >
                {t('drawer.my_profile')}
              </Link>
            </ListItemButton>
          ) : (
            <ListItemButton style={{ padding: 0 }}>
              <Link
                onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'meu perfil')}
                to="/meusDados"
                style={{
                  width: '100%',
                  padding: '8px 16px',
                  color: '#000',
                  textDecoration: 'none',
                }}
              >
                {t('drawer.my_profile')}
              </Link>
            </ListItemButton>
          )}
          <ListItemButton style={{ padding: 0 }}>
            <Link
              to="/sobre"
              style={{
                width: '100%',
                padding: '8px 16px',
                color: '#000',
                textDecoration: 'none',
              }}
              onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'o que é a triibo')}
            >
              {t('drawer.what_is_triibo')}
            </Link>
          </ListItemButton>
          <ListItemButton style={{ padding: 0 }}>
            <Link
              to="/como-usar"
              style={{
                width: '100%',
                padding: '8px 16px',
                color: '#000',
                textDecoration: 'none',
              }}
              onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'como usar')}
            >
              {t('drawer.how_to_use')}
            </Link>
          </ListItemButton>
          <ListItemButton style={{ padding: 0 }}>
            <Link
              to="https://triibo.com.br/triibo-negocios/"
              target="_blank"
              style={{
                width: '100%',
                padding: '8px 16px',
                color: '#000',
                textDecoration: 'none',
              }}
              onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'Solucoes para negocios')}
            >
              {t('drawer.solutions_triibo')}
            </Link>
          </ListItemButton>

          <ListItemButton style={{ padding: 0 }}>
            <Link
              to="/fale-conosco"
              target="new"
              style={{
                width: '100%',
                padding: '8px 16px',
                color: '#000',
                textDecoration: 'none',
              }}
              onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'fale conosco')}
            >
              {t('drawer.contact_us')}
            </Link>
          </ListItemButton>
          <ListItemButton style={{ padding: 0 }}>
            <a
              href={document.location.origin + '/termos-de-uso-dos-servicos-triibo/'}
              target="new"
              style={{
                width: '100%',
                padding: '8px 16px',
                color: '#000',
                textDecoration: 'none',
              }}
              onClick={() => {
                trackEventMatomo('Menu', 'tocar', 'botao', 'termos e políticas de uso');
              }}
            >
              {t('drawer.terms_and_policies')}
            </a>
          </ListItemButton>
          {isAnonymous ? (
            <ListItemButton style={{ width: '100%', padding: 0, color: '#000' }}>
              <Link
                to="/login"
                style={{
                  width: '100%',
                  padding: '8px 16px',
                  color: '#000',
                  textDecoration: 'none',
                }}
              >
                <strong>{t('drawer.login')}</strong>
              </Link>
            </ListItemButton>
          ) : (
            <ListItemButton
              onClick={() => handleLogout()}
              style={{ width: '100%', padding: 0, color: '#000' }}
            >
              <Link
                to="/"
                style={{
                  width: '100%',
                  padding: '8px 16px',
                  color: '#000',
                  textDecoration: 'none',
                }}
              >
                <strong>{t('drawer.exit')}</strong>
              </Link>
            </ListItemButton>
          )}
        </List>
      </Box>
    </SwipeableDrawer>
  );

  if (authenticated === false) {
    return (
      <div className="loading-login">
        <Loading />
      </div>
    );
  } else if (authenticated === null) {
    //window.location = document.location.origin;
    return (
      <div className="loading-login">
        <Loading />
      </div>
    );
  } else {
    return (
      <Box sx={styles.grow}>
        <LoginModal openState={openState} setOpenState={setOpenState} />

        <AppBar>
          <div className="container-topbar">
            <Toolbar>
              <Link onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'logo')} to="/">
                <Box component="img" src={thumbWhite} alt="logo" width="45px" sx={styles.title} />
              </Link>
              <SearchBar />

              <Box sx={styles.sectionDesktop}>
                <Box sx={styles.sectionIcons}>
                  {isAnonymous ? (
                    <>
                      <Link
                        onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'home')}
                        to="/"
                      >
                        <IconButton>
                          {location.pathname === '' || location.pathname === '/' ? (
                            <Home fontSize="large" style={{ color: 'white' }} />
                          ) : (
                            <HomeOutlined fontSize="large" style={{ color: 'white' }} />
                          )}
                        </IconButton>
                      </Link>
                      <Link
                        onClick={() =>
                          trackEventMatomo('Menu', 'tocar', 'botao', 'caixa de entrada')
                        }
                        to="#"
                      >
                        <IconButton onClick={() => openAnonymousModal()}>
                          {location.pathname === '/caixaDeEntrada' ||
                          location.pathname === '/caixaDeEntrada/' ? (
                            <Mail fontSize="large" style={{ color: 'white' }} />
                          ) : (
                            <MailOutline fontSize="large" style={{ color: 'white' }} />
                          )}
                        </IconButton>
                      </Link>
                      <Link
                        onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'carteira')}
                        to="#"
                      >
                        <IconButton onClick={() => openAnonymousModal()}>
                          {location.pathname === '/carteira' ||
                          location.pathname === '/carteira/' ? (
                            <AccountBalanceWallet fontSize="large" style={{ color: 'white' }} />
                          ) : (
                            <AccountBalanceWalletOutlined
                              fontSize="large"
                              style={{ color: 'white' }}
                            />
                          )}
                        </IconButton>
                      </Link>
                    </>
                  ) : (
                    <>
                      <Link
                        onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'home')}
                        to="/"
                      >
                        <IconButton>
                          {location.pathname === '' || location.pathname === '/' ? (
                            <Home fontSize="large" style={{ color: 'white' }} />
                          ) : (
                            <HomeOutlined fontSize="large" style={{ color: 'white' }} />
                          )}
                        </IconButton>
                      </Link>
                      <Link
                        onClick={() =>
                          trackEventMatomo('Menu', 'tocar', 'botao', 'caixa de entrada')
                        }
                        to="/caixaDeEntrada"
                      >
                        <IconButton>
                          {location.pathname === '/caixaDeEntrada' ||
                          location.pathname === '/caixaDeEntrada/' ? (
                            <Mail fontSize="large" style={{ color: 'white' }} />
                          ) : (
                            <MailOutline fontSize="large" style={{ color: 'white' }} />
                          )}
                        </IconButton>
                      </Link>
                      <Link
                        onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'carteira')}
                        to="/carteira"
                      >
                        <IconButton>
                          {location.pathname === '/carteira' ||
                          location.pathname === '/carteira/' ? (
                            <AccountBalanceWallet fontSize="large" style={{ color: 'white' }} />
                          ) : (
                            <AccountBalanceWalletOutlined
                              fontSize="large"
                              style={{ color: 'white' }}
                            />
                          )}
                        </IconButton>
                      </Link>
                    </>
                  )}
                </Box>

                <Box sx={styles.sectionAvatar}>
                  {isAnonymous ? (
                    // TROCAR
                    <Link
                      style={{
                        minWidth: '120px',
                        cursor: 'pointer',
                        textDecoration: 'none',
                      }}
                      to="/login"
                    >
                      <ListItem style={{ minWidth: '120px' }}>
                        <ListItemText
                          style={{ lineHeight: '2.3vh' }}
                          primary={
                            <span style={{ fontWeight: 'bold', color: 'white' }} width="120px">
                              {t('drawer.click_here')}
                            </span>
                          }
                          secondary={
                            <Typography variant="body2" style={{ color: 'white' }}>
                              {t('drawer.signUp')}
                            </Typography>
                          }
                        />
                      </ListItem>
                    </Link>
                  ) : (
                    <ListItem style={{ minWidth: '120px' }}>
                      <ListItemAvatar>
                        <Avatar alt="avatar" src={thumb} />
                      </ListItemAvatar>
                      {/* <ListItemText style={{ lineHeight: '2.3vh' }} primary={<span style={{ fontWeight: 'bold' }} width='120px'>Olá {userInfo.aliasName ? userInfo.aliasName : 'Triiber'},</span>} secondary={<span style={{ color: 'white' }}>Você tem {points} pontos</span>} /> */}
                      <ListItemText
                        style={{ lineHeight: '2.3vh' }}
                        primary={
                          <Typography variant="body2" style={{ fontWeight: 'bold' }} width="120px">
                            {t('nav_bar.hello')},{' '}
                            {userInfo.aliasName ? userInfo.aliasName : 'Triiber'},
                          </Typography>
                        }
                        secondary={
                          <Typography variant="body2" style={{ color: 'white' }}>
                            {points === 1
                              ? t('nav_bar.total_user_points')
                              : t('nav_bar.total_user_points_plural', {
                                  points,
                                })}
                          </Typography>
                        }
                      />
                    </ListItem>
                  )}
                  <LanguageSwitcher />
                  <IconButton
                    edge="end"
                    aria-label="account of current user"
                    aria-controls={menuId}
                    aria-haspopup="true"
                    onClick={handleProfileMenuOpen}
                    color="inherit"
                    // style={{ marginLeft: '10px' }}
                  >
                    <MenuOutlined fontSize="large" />
                  </IconButton>
                </Box>
              </Box>
            </Toolbar>
          </div>
        </AppBar>
        {renderMenu}
        {renderMenuMobile}
        {renderDrawer}

        <main className="main">
          <div className="container" style={{ backgroundColor: '#fff' }}>
            <HomeTriibosCarousel />
          </div>
          <div className="container">
            <Grid container spacing={4} style={{ paddingBottom: 10 }}>
              <Grid item size={{ md: 8, xs: 12 }}>
                <LoggedRoutes setOpenState={setOpenState} reloadOrgs={reloadOrgs} />
              </Grid>
              <Grid
                size={{ md: 4, xs: 12 }}
                style={{
                  height: 0,
                  marginTop: 0,
                  marginBottom: 0,
                  padding: 0,
                }}
              ></Grid>
            </Grid>
          </div>
          <div className="home-side-container" style={{ height: 0 }}>
            <div className="container" style={{ height: 0 }}>
              <Grid
                container
                spacing={4}
                style={{
                  height: 0,
                  marginTop: 0,
                  marginBottom: 0,
                  padding: 0,
                }}
              >
                <Grid
                  size={{ md: 8, xs: 12 }}
                  style={{
                    height: 0,
                    marginTop: 0,
                    marginBottom: 0,
                    padding: 0,
                  }}
                ></Grid>
                <Grid size={{ md: 4, xs: 12 }}>
                  <div className="home-side-content">
                    <HomeImage />
                    <HomeTriibos orgs={orgs} reloadOrgs={reloadOrgs} />
                    <HomeTriibosSuggestion orgs={orgs} reloadOrgs={reloadOrgs} />
                    {/* <DownloadApp /> */}
                  </div>
                </Grid>
              </Grid>
            </div>
          </div>
          <Footer />
        </main>
      </Box>
    );
  }
}

